import { memo } from 'react'

const FieldOfViewButtonContainer = () => {
  return <div id='camera-field-of-view-button-container' />
}

export default memo(FieldOfViewButtonContainer)
